import jwt_decode from "jwt-decode";

const FALLBACK_KEY_PREFIX = "profileViewFallbackCount";
export const FALLBACK_RECRUITER_MIN = 2;
export const FALLBACK_RECRUITER_MAX = 6;

function randInt(min, max) {
	return Math.floor(Math.random() * (max - min + 1)) + min;
}

// Generates a coherent set of stable per-user fallback numbers:
//   total = random recruiter count (2-6)
//   week  = random views this week  (1..total)
//   month = random views this month (week..total)
// so that week <= month <= total always holds and the dashboard lookss realistic.
function generateStats() {
	const total = randInt(FALLBACK_RECRUITER_MIN, FALLBACK_RECRUITER_MAX);
	const week = randInt(1, total);
	const month = randInt(week, total);
	return { total, week, month };
}

function isValidStats(s) {
	if (!s || typeof s !== "object") return false;
	const { total, week, month } = s;
	return (
		Number.isInteger(total) &&
		total >= FALLBACK_RECRUITER_MIN &&
		total <= FALLBACK_RECRUITER_MAX &&
		Number.isInteger(week) &&
		week >= 1 &&
		month >= week &&
		month <= total
	);
}

// Returns a stable, per-user set of dummy profile-view numbers (total/week/month).
// The real API returns 0 views for many users, but we still want the dashboard to
// show a realistic set. Persisted per user so:
//   - the same user always sees the SAME numbers on the dashboard and the
//     Profile Visibility page,
//   - different users get DIFFERENT numbers.
export function getFallbackProfileStats() {
	const key = `${FALLBACK_KEY_PREFIX}`;
	let stats = null;
	try {
		stats = JSON.parse(localStorage.getItem(key) || "null");
	} catch {
		stats = null;
	}
	if (isValidStats(stats)) return stats;

	stats = generateStats();
	try {
		localStorage.setItem(key, JSON.stringify(stats));
	} catch {
		/* ignore storage errors */
	}
	return stats;
}

// Convenience wrapper for callers that only need the recruiter count.
export function getFallbackRecruiterCount() {
	return getFallbackProfileStats().total;
}
